import React from 'react';
import { Carousel } from 'react-materialize';

function Lessons() {
    return (
        <React.Fragment>
            <section className='filter'>
                <br />
                <div className='title-principal'>
                    <h1>Lessons</h1>
                    <p>Time flies, learn yoga today and see results today.</p>
                </div>
                <br />
                <Carousel
                    carouselId="Carousel-34"
                    options={{
                        dist: -100,
                        duration: 200,
                        fullWidth: false,
                        indicators: false,
                        noWrap: false,
                        numVisible: 5,
                        onCycleTo: null,
                        padding: 0,
                        shift: 0
                    }}
                >
                <div className='course'>
                <h4>Yin yoga</h4>
                <img src="https://images.pexels.com/photos/3965401/pexels-photo-3965401.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"  alt=""></img>
                </div>
                
                <div className='course'>
                <h4>Yoga iyengar</h4>
                <img src="https://images.pexels.com/photos/2529371/pexels-photo-2529371.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"  alt=""></img>
                </div>

                <div className='course'>
                <h4>Hatha yoga</h4>
                <img src="https://images.pexels.com/photos/2780762/pexels-photo-2780762.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"  alt=""></img>
                </div>

                <div className='course'>
                <h4>Yoga vinyasa</h4>
                <img src="https://images.pexels.com/photos/3823086/pexels-photo-3823086.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"  alt=""></img>
                </div>
                
                <div className='course'>
                <h4>Acroyoga</h4>
                <img src="https://images.pexels.com/photos/37351/silhouette-aerialist-female-woman.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"  alt=""></img>
                </div>
                

                <div className='course'>
                <h4>Jivamukti</h4>
                <img src="https://images.pexels.com/photos/3049225/pexels-photo-3049225.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"  alt=""></img>
                </div>
                
                
                </Carousel>
            </section>

        </React.Fragment>
    );
}
export default Lessons;